export const MULTISELECT_ALL_OPTION = {
  label: "All",
  value: "all",
};

export const DOCUMENTS_EXPIRATION_REPORT = "documents-expiration";
export const GFE_PROCEDURES_EXPIRATION_REPORT = "gfe-procedures-expiration";

export const EXPIRATION_REPORT_SYSNAMES = [
  DOCUMENTS_EXPIRATION_REPORT,
  GFE_PROCEDURES_EXPIRATION_REPORT,
];

export const EXPIRATION_DATE_PRESETS = ["30_days", "60_days", "90_days"];
